import { render, staticRenderFns } from "./Profile-1.vue?vue&type=template&id=d1e4632a&"
import script from "./Profile-1.vue?vue&type=script&lang=js&"
export * from "./Profile-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1e4632a')) {
      api.createRecord('d1e4632a', component.options)
    } else {
      api.reload('d1e4632a', component.options)
    }
    module.hot.accept("./Profile-1.vue?vue&type=template&id=d1e4632a&", function () {
      api.rerender('d1e4632a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/profile/Profile-1.vue"
export default component.exports